// extracted by mini-css-extract-plugin
export default {"root":"AdminOnboardingPage_root__1kAwo"};